import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSyringe, faDog, faPaw, faGift,
  faUserShield, faWalking, faHandshake, faTrash
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { routes } from '../config/utility';

const Setting = () => {
  const settingItems = [
    {
      icon: faSyringe,
      label: 'Pet Allergy',
      path: routes.pet_allergy,
      description: 'Manage pet allergies that owners should be aware of. Add, edit, or remove common pet allergies to help maintain pet health records.'
    },
    {
      icon: faDog,
      label: 'Pet Breed',
      path: routes.pet_breed,
      description: 'Control the list of available pet breeds. Add new breeds, modify existing ones, and organize them by pet types.'
    },
    {
      icon: faPaw,
      label: 'Pet Type',
      path: routes.pet_type,
      description: 'Manage different types of pets supported by the platform. Configure pet categories and their associated characteristics.'
    },
    {
      icon: faGift,
      label: 'Promo Code',
      path: routes.promo_code,
      description: 'Create and manage promotional codes for special offers. Set discount values, validity periods, and usage limits.'
    },
    {
      icon: faUserShield,
      label: 'Membership',
      path: routes.membership,
      description: 'Configure membership plans, their benefits, and pricing. Control access levels and special features for different membership tiers.'
    },
    {
      icon: faWalking,
      label: 'Walk Tool',
      path: routes.walk_tool,
      description: 'Manage walking equipment and tools available for pet walks. Add, update, or remove walking accessories and their prices.'
    },
    {
      icon: faHandshake,
      label: 'Partner',
      path: routes.partner,
      description: 'Manage business partners and their profiles. Control partner information, services, and collaboration details.'
    },
    {
      icon: faTrash,
      label: 'Account Deletions',
      path: routes.account_deletion_admin,
      description: 'Manage user account deletion requests. Review, approve, or reject deletion requests and handle data export requirements.'
    }
  ];

  return (
    <div className="container mx-auto px-4 ">
      <h1 className="text-3xl font-bold text-tblue mb-8">Settings Dashboard</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {settingItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden"
          >
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mr-4">
                  <FontAwesomeIcon
                    icon={item.icon}
                    className="text-2xl text-primary"
                  />
                </div>
                <h2 className="text-xl font-semibold text-gray-800">
                  {item.label}
                </h2>
              </div>
              <p className="text-gray-600 leading-relaxed">
                {item.description}
              </p>
              <div className="mt-4 flex justify-end">
                <span className="text-primary font-medium hover:underline">
                  Manage →
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Setting;